import { render, staticRenderFns } from "./ReleaseOther.vue?vue&type=template&id=596197b6&"
import script from "./ReleaseOther.vue?vue&type=script&lang=js&"
export * from "./ReleaseOther.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseOther.vue?vue&type=style&index=0&id=596197b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports